import React, { Component } from 'react'
import ReactTooltip from 'react-tooltip'

export default class DraftCommentIndicator extends Component {
  constructor() {
    super()
    this.state = {
      id: Math.random()
    }
  }

  render() {
    return (
      <div
        className="draft-comment-indicator"
        data-for={`draftCommentTooltip-${this.state.id}`}
        data-tip="Draft Comment"
      >
        <ReactTooltip
          id={`draftCommentTooltip-${this.state.id}`}
          effect="solid"
          offset={{ top: -2 }}
        />
        <div className="draft-comment-indicator-icon" />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/mini/comments/DraftCommentIndicator.js